import { jsx as t } from "react/jsx-runtime";
function e(o) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: "19",
      height: "14",
      viewBox: "0 0 19 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...o,
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M18 5H5M18 1H1M18 9H1M18 13H5",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
export {
  e as default
};
